// import _ from 'lodash'
import vm from '../main'

const internals = {}

internals.addDriver = function (driver) {
  // Filter out properties not needed
  driver = (({
    driverName,
    driverLastName,
    mobileNumber,
    dateOfBirth,
    // manager,
    languageKnown,
    defaultLanguage,
    lisenceNumber,
    status,
    addressDetails,
    driverPin,
    photo,
    licenseExpiryDate,
    region,
    documents,
    driverImage,
    // deviceId,
    // vehicleId,
    _id,
    DDTNumber,
    hazNumber,
    ddtExpiryDate,
    hazExpiryDate
  }) => {
    return {
      driverName,
      driverLastName,
      mobileNumber,
      dateOfBirth,
      // manager,
      languageKnown,
      defaultLanguage,
      // vehicleId,
      status,
      lisenceNumber,
      addressDetails,
      driverPin,
      photo,
      licenseExpiryDate,
      region,
      documents,
      driverImage,
      // deviceId,
      _id,
      DDTNumber,
      hazNumber,
      ddtExpiryDate,
      hazExpiryDate
    }
  })(driver)

  return vm.$driverDataRepository
    .create(driver)
    .then(result => {
      driver = result.data
      return driver
    })
    .catch(error => {
      console.error('deviceService.createRole-error:\n', error)
      throw error
    })
}

internals.updateDriver = function (driver) {
  driver = Object.assign({}, driver)
  // Filter out properties not needed
  driver = (({
    driverName,
    driverLastName,
    mobileNumber,
    dateOfBirth,
    // manager,
    languageKnown,
    defaultLanguage,
    lisenceNumber,
    status,
    addressDetails,
    driverPin,
    photo,
    licenseExpiryDate,
    region,
    documents,
    // deviceId,
    _id,
    // vehicleId,
    DDTNumber,
    hazNumber,
    ddtExpiryDate,
    hazExpiryDate
  }) => {
    return {
      driverName,
      driverLastName,
      mobileNumber,
      dateOfBirth,
      // manager,
      languageKnown,
      defaultLanguage,
      status,
      lisenceNumber,
      addressDetails,
      driverPin,
      photo,
      licenseExpiryDate,
      region,
      documents,
      // deviceId,
      _id,
      // vehicleId,
      DDTNumber,
      hazNumber,
      ddtExpiryDate,
      hazExpiryDate
    }
  })(driver)
  return vm.$driverDataRepository
    .update(driver._id, driver)
    .then(result => {
      driver = result.data
      return driver
    })
    .catch(error => {
      console.error('driverUpdate.update-error:\n', error)
      throw error
    })
}

export default internals



// WEBPACK FOOTER //
// ./src/services/driver.service.js